/* Dabi Deri — ürün sayfası toptan paneli.
   Panel body'ye taşınır (ürün sütunundaki transform/sticky kapsayıcılar sabit
   konumu bozmasın), kademe tablosu + adet hesaplayıcı canlı çalışır, teklif
   ve WhatsApp bağlantıları seçilen adetle güncellenir. */
(() => {
  const fmtMoney = (cents, f) => {
    const n = (Number(cents) || 0) / 100;
    const m = (f || '').match(/\{\{\s*(\w+)\s*\}\}/);
    const key = m ? m[1] : 'amount';
    const parts = (dec, thou, d) => { let [i, fr] = n.toFixed(d).split('.'); i = i.replace(/\B(?=(\d{3})+(?!\d))/g, thou); return fr !== undefined ? i + dec + fr : i; };
    let out;
    switch (key) {
      case 'amount_no_decimals': out = parts('', ',', 0); break;
      case 'amount_with_comma_separator': out = parts(',', '.', 2); break;
      case 'amount_no_decimals_with_comma_separator': out = parts('', '.', 0); break;
      default: out = parts('.', ',', 2);
    }
    return f ? f.replace(/\{\{\s*\w+\s*\}\}/, out) : out;
  };

  const init = (root) => {
    const btn = root.querySelector('[data-dabi-pwh-open]');
    const drawer = root.querySelector('[data-dabi-pwh]');
    if (!btn || !drawer || btn.dataset.ready === 'true') return;
    btn.dataset.ready = 'true';
    document.body.appendChild(drawer);
    // karttaki toptan rozetinden gelindiyse (#toptan) paneli kendiliğinden aç
    if (window.location.hash === '#toptan') setTimeout(() => btn.click(), 350);

    const price = Number(drawer.dataset.price) || 0;
    const moq = Number(drawer.dataset.moq) || 0;
    const fmt = drawer.dataset.moneyFormat;
    const tiers = Array.from(drawer.querySelectorAll('[data-tier]')).map((el) => ({ el, min: Number(el.dataset.min), pct: Number(el.dataset.pct) })).sort((a, b) => a.min - b.min);
    const qty = drawer.querySelector('[data-pwh-qty]');
    const range = drawer.querySelector('[data-pwh-range]');
    const unitEl = drawer.querySelector('[data-pwh-unit]');
    const totalEl = drawer.querySelector('[data-pwh-total]');
    const savingEl = drawer.querySelector('[data-pwh-saving]');
    const hint = drawer.querySelector('[data-pwh-hint]');
    const quote = drawer.querySelector('[data-pwh-quote]');
    const wa = drawer.querySelector('[data-pwh-wa]');
    if (range && tiers.length) range.max = String(Math.max(200, tiers[tiers.length - 1].min * 2));

    const update = (n) => {
      n = Math.max(1, Math.round(Number(n) || 1));
      if (qty && Number(qty.value) !== n) qty.value = n;
      if (range) range.value = String(Math.min(n, Number(range.max)));
      let active = null;
      tiers.forEach((t) => { if (n >= t.min) active = t; });
      tiers.forEach((t) => t.el.classList.toggle('is-active', t === active));
      if (unitEl) {
        const pct = active ? active.pct : 0;
        const unit = Math.round(price * (100 - pct) / 100);
        unitEl.textContent = fmtMoney(unit, fmt);
        totalEl.textContent = fmtMoney(unit * n, fmt);
        savingEl.textContent = pct ? `${fmtMoney((price - unit) * n, fmt)} (-%${pct})` : '—';
      }
      if (hint) {
        const next = tiers.find((t) => t.min > n);
        if (moq && n < moq) hint.textContent = (drawer.dataset.lBelow || '').replace('{n}', moq);
        else if (next) hint.textContent = (drawer.dataset.lNext || '').replace('{n}', next.min - n).replace('{p}', next.pct);
        else hint.textContent = tiers.length ? drawer.dataset.lTop || '' : '';
      }
      // Teklif ve WhatsApp bağlantıları seçilen adetle
      if (quote) {
        const u = new URL(drawer.dataset.quoteUrl || '/pages/toptan-satis', window.location.origin);
        u.searchParams.set('urun', drawer.dataset.title);
        u.searchParams.set('adet', String(n));
        u.hash = 'basvuru';
        quote.href = u.pathname + u.search + u.hash;
      }
      if (wa) {
        const text = `${drawer.dataset.waText || ''} ${drawer.dataset.title} — ${n} adet\n${drawer.dataset.url}`;
        wa.href = `https://wa.me/${drawer.dataset.wa}?text=${encodeURIComponent(text)}`;
      }
    };
    qty?.addEventListener('input', () => update(qty.value));
    range?.addEventListener('input', () => update(range.value));
    drawer.querySelectorAll('[data-pwh-step]').forEach((b) => b.addEventListener('click', () => update((Number(qty.value) || 0) + Number(b.dataset.pwhStep))));
    update(qty ? qty.value : 1);

    let last = null;
    const close = () => {
      drawer.hidden = true;
      document.documentElement.classList.remove('dabi-pwh-open');
      document.body.classList.remove('dabi-pwh-open');
      btn.setAttribute('aria-expanded', 'false');
      if (last) last.focus();
    };
    const open = () => {
      last = document.activeElement;
      drawer.hidden = false;
      document.documentElement.classList.add('dabi-pwh-open');
      document.body.classList.add('dabi-pwh-open');
      btn.setAttribute('aria-expanded', 'true');
      drawer.querySelector('.dabi-pwh__close')?.focus();
    };
    btn.addEventListener('click', open);
    drawer.querySelectorAll('[data-dabi-pwh-close]').forEach((c) => c.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (drawer.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        const f = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input')).filter((x) => x.offsetParent !== null);
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
  };
  const run = () => document.querySelectorAll('.dabi-pwh').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
